import { VOLATILITY_SOURCE_ALIAS } from './constants';
import { ConditionsParams } from './types';

const conditions = ({ cell, tableData, sheet }: ConditionsParams) => {
  const { isDisabled } = tableData;
  const { cells } = sheet;
  const { alias } = cell;
  if (alias === VOLATILITY_SOURCE_ALIAS) {
    const volatilityCell = cells.B5;

    volatilityCell.readOnly = ![null, ''].includes(cell.value as string) || isDisabled;
  }
};

export default conditions;
